import React, { type FC } from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { LabelText } from "@components/styles"
import { Autoplay, Lazy } from "swiper"
// eslint-disable-next-line
import { SwiperSlide } from "swiper/react"
import type { SponsorsProps } from "./types"
import {
    AdditionalPartnerImageWrapper,
    AdditionalPartnersWrapper,
    AdditionalPartnerTitle,
    Content,
    ImageWrapper,
    Item,
    LogosWrapper,
    SponsorItems,
    SponsorsWrapper,
    StyledSwiper
} from "./styles"

const Sponsors: FC<SponsorsProps> = ({ content, partners, additionalPartners }) => {
    return <SponsorsWrapper>
        {content && <Content dangerouslySetInnerHTML={{ __html: content }} />}
        <SponsorItems>
            {partners?.map((partner) => (
                <Item key={partner.id} isHalfColumn={partner.width === "half"}>
                    {" "}
                    <LabelText>{partner.title}</LabelText>
                    {" "}
                    <LogosWrapper>
                        {partner?.logos?.map((logo, index) => (
                            // eslint-disable-next-line react/no-array-index-key
                            <ImageWrapper key={`${logo.id}_${index}`}>
                                <GatsbyImage
                                    alt={logo.alternativeText}
                                    image={getImage(logo.file)}
                                />
                            </ImageWrapper>
                        ))}
                    </LogosWrapper>
                </Item>
            ))}
        </SponsorItems>
        {additionalPartners && <AdditionalPartnersWrapper>
            <AdditionalPartnerTitle>
                {additionalPartners.title}
            </AdditionalPartnerTitle>
            {additionalPartners?.images?.length && <StyledSwiper
                loop
                lazy
                centeredSlides
                //                loopAdditionalSlides={8}
                speed={4000}
                autoplay={{ delay: 1, disableOnInteraction: false }}
                mousewheel={false}
                keyboard={false}
                slidesPerView="auto"
                breakpoints={{ 768: { spaceBetween: 60 } }}
                spaceBetween={40}
                modules={[Autoplay, Lazy]}
            >
                {additionalPartners?.images?.map((image, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <SwiperSlide key={`${image.id}_${index}`}>
                        <AdditionalPartnerImageWrapper>
                            <GatsbyImage
                                className="swiper-lazy"
                                loading="eager"
                                alt={image.alternativeText}
                                image={getImage(image.file)}
                            />
                        </AdditionalPartnerImageWrapper>
                    </SwiperSlide>
                ))}
            </StyledSwiper>}
        </AdditionalPartnersWrapper>}
    </SponsorsWrapper>
}

export default Sponsors
